import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  createUserSuccess: ['response'],
  createUserFailure: null,

  getAllUserStatsSuccess: ['response'],
  getAllUserStatsFailure: null,

  getUsersRequest: null,
  getUsersSuccess: ['response'],
  getUsersFailure: null,
  clearSuccessUsersRequest: null,

  getUsersInfractionsRequest: ['userId', 'startDate', 'endDate', 'timeZone', 'page'],
  getUsersInfractionsSuccess: ['response'],
  getUsersInfractionsFailure: null,

  getUsersActivitiesRequest: ['userId', 'dateStart', 'dateEnd', 'timezoneOffset', 'page', 'limit'],
  getUsersActivitiesSuccess: ['response'],
  getUsersActivitiesFailure: null,

  getUsersTaskHistoryRequest: ['userId', 'dateStart', 'dateEnd', 'timezoneOffset', 'page', 'limit'],
  getUsersTaskHistorySuccess: ['response'],
  getUsersTaskHistoryFailure: null,

  getUsersCommissionHistoryRequest: ['userId', 'dateStart', 'dateEnd', 'timezoneOffset', 'page', 'limit'],
  getUsersCommissionHistorySuccess: ['response'],
  getUsersCommissionHistoryFailure: null,
  getUsersActivityOverviewByIdRequest: [
    'userId',
    'dateStart',
    'dateEnd',
    'previousStartDate',
    'previousEndDate',
    'timezoneOffset',
  ],
  getUsersActivityOverviewByIdSuccess: ['response'],
  getUsersActivityOverviewByIdFailure: null,

  getUsersByBranchRequest: null,
  getUsersByBranchSuccess: ['response'],
  getUsersByBranchFailure: null,

  clearActivityList: null,
  getUsersActivityPageRequest: null,
  getUsersActivityPageSuccess: ['response'],
  getUsersActivityPageFailure: null,

  getOverallUserActivityRequest: ['pageNo', 'userId', 'activityType'],
  getOverallUserActivitySuccess: ['response'],
  getOverallUserActivityFailure: null,

  employeeFileListRequest: ['userId'],
  employeeFileListSuccess: ['response'],
  employeeFileListFailure: ['userId'],

  uploadEmpFileRequest: ['userId', 'file', 'title'],
  uploadEmpFileSuccess: ['response'],
  uploadEmpFileFailure: ['userId'],

  clearCreatedUserRequest: null,
  clearDisabledUserRequest: null,
  clearActivatedUserRequest: null,

  // Clear all caches
  clearHumanResourcesRequest: null,
  setStatusUserLimitModal: ['isOpen'],
});

export const HumanResourcesTypes = Types;
export default Creators;
